const _excluded = ["children", "useEmptyPlaceholder", "animated", "hover"],
  _excluded2 = ["src", "srcSet"],
  _excluded3 = ["className"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './LazyPicture.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
import { useInView } from 'react-intersection-observer';
import { qsToObject } from '../../../utils/querystring';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
const LazyPicture = _ref => {
  let {
      children,
      useEmptyPlaceholder = false,
      animated = true,
      hover = false
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const [ref, inView] = useInView({
    triggerOnce: true
  });
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const {
    padding,
    cw,
    ch
  } = React.useMemo(() => {
    if (typeof window === 'undefined') return {
      padding: 0,
      cw: '',
      ch: ''
    };
    return children.reduceRight((acc, child) => {
      const {
        src,
        srcSet,
        media
      } = child.props;
      const {
        cw,
        ch
      } = media ? qsToObject(srcSet) : qsToObject(src);
      if (!cw || !ch) return acc;
      const mq = media && window.matchMedia(media);
      if (media && (!mq || !mq.matches)) return acc;
      const padding = parseInt(ch) * 100 / parseInt(cw);
      return {
        padding,
        cw,
        ch
      };
    }, {
      padding: 0,
      cw: '',
      ch: ''
    });
  }, [children]);
  const isVerticalImage = padding > 100;
  const processedChildren = React.useMemo(() => {
    if (inView || !animated || pageEditing) return children;
    return children.map((child, index) => {
      const _child$props = child.props,
        {
          src,
          srcSet
        } = _child$props,
        props = _objectWithoutProperties(_child$props, _excluded2);
      const key = `${child.type.toString()}-${index}`;
      return child.props.src ? /*#__PURE__*/React.createElement(child.type, _extends({}, props, {
        "data-src": src,
        key: key
      })) : /*#__PURE__*/React.createElement(child.type, _extends({}, props, {
        "data-srcset": srcSet,
        key: key
      }));
    });
  }, [inView, children, animated]);

  // ignoring classname prop from upstream
  const {
      className
    } = otherProps,
    pictureProps = _objectWithoutProperties(otherProps, _excluded3);
  const pictureClassName = `${picture} ${animated ? animatedPicture : null} ${className ? className : null}`;
  const Picture = /*#__PURE__*/React.createElement("picture", _extends({
    ref: ref,
    className: `${pictureClassName} ${hover ? 'empty-placeholder--hover' : ''}`
  }, pictureProps), processedChildren);
  return useEmptyPlaceholder && padding ? /*#__PURE__*/React.createElement(StyledWrapper, {
    className: "empty-placeholder",
    padding: padding,
    cw: cw,
    ch: ch,
    isVerticalImage: isVerticalImage
  }, Picture) : Picture;
};
const StyledWrapper = /*#__PURE__*/styled("div")({
  name: "StyledWrapper",
  class: "s17v4aoz",
  vars: {
    "s17v4aoz-0": [props => props.isVerticalImage && props.cw ? '100%' : 'unset'],
    "s17v4aoz-1": [props => props.isVerticalImage && props.ch ? '100%' : 'unset'],
    "s17v4aoz-2": [props => props.isVerticalImage && props.cw ? `${props.cw}px` : 'unset'],
    "s17v4aoz-3": [props => props.isVerticalImage && props.ch ? `${props.ch}px` : 'unset'],
    "s17v4aoz-4": [props => `${props.padding}%`]
  }
});
const picture = "p1h540cx";
const animatedPicture = "a1rjuo98";
export default LazyPicture;